module.exports = new __parcel__URL__("periscope-page-full-layout.tpl.243222d7.svg").toString();